import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';
import { InputTabsCoachmarkComponent } from '../coach-mark/coach-mark.component';

export interface InputTab {
  title: string;
  icon?: string;
  activeIcon?: string;
}

@Component({
  selector: 'input-tabs',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent, InputTabsCoachmarkComponent],
  templateUrl: './input-tabs.component.html',
  styleUrl: './input-tabs.component.scss'
})
export class InputTabsComponent {
  @Input() tabs: InputTab[] = [];
  @ViewChild('tabsContainer', { static: false }) tabsContainer?: ElementRef;
  @Output() tabChanged = new EventEmitter<void>();

  currentTabIndex = 0;

  constructor(private readonly adobeLaunchService: AdobeLaunchService) {}

  get isFirstTab(): boolean {
    return this.currentTabIndex === 0;
  }

  get isLastTab(): boolean {
    return this.currentTabIndex === this.tabs.length - 1;
  }

  nextTab(): void {
    if (!this.isLastTab) {
      this.currentTabIndex++;
      this.tabChanged.emit();
      this.adobeLaunchService.subPageViewed('roth conversion details', 'N');
      this.adobeLaunchService.captureCtaButton('arrow-roth-calculator','betr calculator');
    }
  }

  previousTab(): void {
    if (!this.isFirstTab) {
      this.currentTabIndex--;
      this.tabChanged.emit();
      this.adobeLaunchService.subPageViewed('client tax information', 'N');
      this.adobeLaunchService.captureCtaButton('arrow-client-calculator','betr calculator');
    }
  }

  goToTab(index: number): void {
    if (index >= 0 && index < this.tabs.length && index !== this.currentTabIndex) {
      this.currentTabIndex = index;
      const subPage = index === 0 ? 'client tax information' : 'roth conversion details';
      this.adobeLaunchService.subPageViewed(subPage, 'Y');
    }
  }
}
